<template>
  <div>
    <Modal v-model="modal1" width="1200" :title="ruleTitle" class-name="commonModalStyles"
      :transfer="false" :mask-closable="false" @on-visible-change="visibleChange">
      <Spin fix v-if="spinShow"></Spin>
      <Row :gutter="10">
        <Col :span="15">
          <!--已选规则-->
          <div class="normalTop">
            <div class="modalItem rulesRightHeight">
              <div class="modalItemHeader">
                <h6>{{ $t('key1001379') }}</h6>
              </div>
              <div class="modalItemContent">
                <template v-if="rules !== null && rules.length > 0">
                  <template v-for="(ruleItem, index) in rules">
                    <div v-if="ruleItem._check" class="mb10">
                      <div>
                        <span class="group-description">{{ ruleItem.groupDescription }}</span>
                        <span>{{ ruleItem._prefixText }}</span>

                        <!--是否类型-->
                        <template v-if="ruleItem._ruleType === 'IS'">
                          <Select
                            v-if="ruleItem.items[0]._isOperation"
                            v-model="ruleItem.values[ruleItem.items[0].name]"
                            @on-change="validRule(ruleItem.id)"
                            class="wid-70 ml10"><Option value="1">{{ $t('key1000392') }}</Option><Option value="0">{{ $t('key1000393') }}</Option>
                          </Select>
                          <span v-else class="edit-style" @click="editOperation(index,0)">{{ ruleItem.items[0].value === '0' ? $t('key1000393') : $t('key1000392') }}</span>
                        </template>

                        <!--单个input-->
                        <template v-else-if="ruleItem._ruleType === 'INPUT'">
                          <Input v-if="ruleItem.items[0]._isOperation" class="wid-150 ml10" v-model.trim="ruleItem.values[ruleItem.items[0].name]" @on-change="validRule(ruleItem.id)" clearable/>
                          <span v-else class="edit-style" @click="editOperation(index,0)">{{ ruleItem.values[ruleItem.items[0].name] ? ruleItem.values[ruleItem.items[0].name] : ruleItem._guidanceText }}</span>
                        </template>

                        <!--两个checkbox input 选择-->
                        <template v-else-if="ruleItem._ruleType === 'TCI'">
                          <Poptip
                            transfer
                            width="500"
                            placement="bottom">
                              <span class="blueColor cursor">
                                {{ $t('key1001364') }}
                                <span class="mr10"
                                  v-if="ruleItem.values['skus']
                                        && ruleItem.values['skus'].length > 0
                                        && ['CORE-YPDR-009','CORE-YCCR-014','DISTRIBUTOR-DCCR-A017','DISTRIBUTOR-DWCR-A017'].includes(ruleItem.id)">{{ $t('key1001380') }}{{ ruleItem.values['skus'] }}</span>
                                <span v-if="ruleItem.values['beginChecked'] || ruleItem.values['endChecked']">
                                  <span v-if="ruleItem.values['beginChecked']">
                                    <span v-if="ruleItem.values.hasOwnProperty('beginType')">
                                      <span v-if="ruleItem.values['beginType'] === '0'">&ge;</span>
                                      <span v-if="ruleItem.values['beginType'] === '1'">&gt;</span>
                                      <span v-if="ruleItem.values['beginType'] === '2'">=</span>
                                      {{ ruleItem.values['beginValue'] }}
                                    </span>
                                    <span v-else-if="ruleItem.values.hasOwnProperty('startType')">
                                      <span v-if="ruleItem.values['startType'] === '0'">&ge;</span>
                                      <span v-if="ruleItem.values['startType'] === '1'">&gt;</span>
                                      <span v-if="ruleItem.values['startType'] === '2'">=</span>
                                      {{ ruleItem.values['startValue'] }}
                                    </span>
                                  </span>
                                  <span v-if="ruleItem.values['endChecked']">
                                    <span v-if="ruleItem.values['endType'] ==='0'">&lt;</span>
                                    <span v-if="ruleItem.values['endType'] ==='1'">&le;</span>{{ ruleItem.values['endValue'] }}
                                  </span>
                                </span>
                                <span class="cpd"
                                  v-if="ruleItem.values['computeWeightFactor'] !== 0
                                        && ruleItem.values['computeWeightFactorChecked']
                                        && ['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">
                                        {{ $t('key1001381') }}<span>{{ ruleItem.values['computeWeightFactor'] }}</span>
                                 </span>
                              </span>
                            <template #content>
                              <div class="keywordString">
                                <span v-if="['CORE-YPDR-008','DISTRIBUTOR-DCCR-A016','DISTRIBUTOR-DWCR-A016'].includes(ruleItem.id)">{{ $t('key1001382') }}</span>
                                <span v-if="['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">{{ $t('key1001383') }}</span>
                                <span v-else-if="['DISTRIBUTOR-DCCR-A019','DISTRIBUTOR-DWCR-A019','CORE-YCCR-016'].includes(ruleItem.id)">{{ $t('key1001384') }}</span>
                                <span v-else-if="['DISTRIBUTOR-DCCR-A020','DISTRIBUTOR-DWCR-A020','CORE-YCCR-017'].includes(ruleItem.id)">{{ $t('key1001385') }}</span>
                                <span v-else-if="['DISTRIBUTOR-DCCR-A021','DISTRIBUTOR-DWCR-A021','CORE-YCCR-018'].includes(ruleItem.id)">{{ $t('key1001386') }}</span>
                                <span v-else-if="['DISTRIBUTOR-DCCR-A022','DISTRIBUTOR-DWCR-A022','CORE-YCCR-019'].includes(ruleItem.id)">{{ $t('key1001387') }}</span>
                                <span v-else-if="ruleItem.id === 'CORE-YCCR-013'">{{ $t('key1001388') }}</span>
                                <span v-else-if="['DISTRIBUTOR-DCCR-A012','CORE-YCCR-010', 'DISTRIBUTOR-DWCR-A012'].includes(ruleItem.id)"> {{ $t('key1001389') }}</span>
                                <div v-else-if="['CORE-YPDR-009','CORE-YCCR-014','DISTRIBUTOR-DCCR-A017','DISTRIBUTOR-DWCR-A017'].includes(ruleItem.id)">
                                  <span>{{ $t('key1001390') }}</span>
                                  <Input
                                    style="width:300px;marginLeft:10px;"
                                    type="textarea"
                                    :placeholder="$t('key1001343')"
                                    v-model.trim="ruleItem.values['skus']"></Input>
                                  <br>
                                  <span style="marginTop:10px;">{{ $t('key1001391') }}</span>
                                </div>
                                <div class="platformSelect normalTop">
                                  <Checkbox v-model="ruleItem.values['beginChecked']"></Checkbox>
                                  <template v-if="ruleItem.values.hasOwnProperty('beginType')">
                                    <Select
                                      v-model="ruleItem.values['beginType']"
                                      style="width:120px;"
                                      size="small"
                                      :disabled="!ruleItem.values['beginChecked']">
                                      <Option :value="'0'">&ge;</Option>
                                      <Option :value="'1'">&gt;</Option>
                                      <Option :value="'2'">=</Option>
                                    </Select>
                                    <InputNumber
                                      :min="0"
                                      size="small"
                                      style="marginLeft:10px;"
                                      :disabled="!ruleItem.values['beginChecked']"
                                      v-model="ruleItem.values['beginValue']"></InputNumber>
                                  </template>
                                  <template v-if="ruleItem.values.hasOwnProperty('startType')">
                                    <Select
                                      v-model="ruleItem.values['startType']"
                                      style="width:120px;"
                                      size="small"
                                      :disabled="!ruleItem.values['beginChecked']">
                                      <Option :value="'0'">&ge;</Option>
                                      <Option :value="'1'">&gt;</Option>
                                      <Option :value="'2'">=</Option>
                                    </Select>
                                    <InputNumber
                                      :min="0"
                                      size="small"
                                      style="marginLeft:10px;"
                                      :disabled="!ruleItem.values['beginChecked']"
                                      v-model="ruleItem.values['startValue']"></InputNumber>
                                  </template>
                                </div>
                                <div class="platformSelect normalTop">
                                  <Checkbox v-model="ruleItem.values['endChecked']"></Checkbox>
                                  <Select
                                    v-model="ruleItem.values['endType']"
                                    style="width:120px;"
                                    size="small"
                                    :disabled="!ruleItem.values['endChecked']">
                                    <Option :value="'0'">&lt;</Option>
                                    <Option :value="'1'">&le;</Option>
                                  </Select>
                                  <InputNumber
                                    :min="0"
                                    size="small"
                                    style="marginLeft:10px;"
                                    :disabled="!ruleItem.values['endChecked']"
                                    v-model="ruleItem.values['endValue']"></InputNumber>
                                </div>
                                <div class="platformSelect normalTop" v-if="['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">
                                  <Checkbox
                                    :disabled="(!ruleItem.values['beginChecked'] && !ruleItem.values['endChecked'])"
                                    v-model="ruleItem.values['computeWeightFactorChecked']"></Checkbox>
                                  {{ $t('key1001392') }}
                                  <span>{{ $t('key1001381') }}</span>
                                  <InputNumber
                                    :min="0"
                                    size="small"
                                    style="marginLeft:10px;"
                                    :disabled="!ruleItem.values['computeWeightFactorChecked']"
                                    v-model="ruleItem.values['computeWeightFactor']"></InputNumber>
                                </div>
                                <p style="marginTop:10px;" v-if="['DISTRIBUTOR-DCCR-A018','DISTRIBUTOR-DWCR-A018','CORE-YCCR-015'].includes(ruleItem.id)">
                                  {{ $t('key1001393') }}<br>{{ $t('key1001394') }}<br>{{ $t('key1001395') }}<br>{{ $t('key1001396') }}
                                </p>
                                <p class="mt10"
                                  v-else-if="['CORE-YCCR-016','CORE-YCCR-017','CORE-YCCR-018','DISTRIBUTOR-DCCR-A019','DISTRIBUTOR-DWCR-A019','DISTRIBUTOR-DCCR-A020','DISTRIBUTOR-DWCR-A020','DISTRIBUTOR-DWCR-A021','DISTRIBUTOR-DCCR-A021'].includes(ruleItem.id)">{{ $t('key1001397') }}<br> {{ $t('key1001398') }}
                                  <br> {{ $t('key1001399') }}</p>
                                <p style="marginTop:10px;" v-else-if="['DISTRIBUTOR-DCCR-A022','DISTRIBUTOR-DWCR-A022','CORE-YCCR-019'].includes(ruleItem.id)">
                                  {{ $t('key1001397') }}<br> {{ $t('key1001398') }}<br> {{ $t('key1001400') }} <br>{{ $t('key1001401') }}
                                </p>
                              </div>
                            </template>

                          </Poptip>
                        </template>

                        <!--非通用单个模板-->
                        <template v-else>
                          <!--订单/交易/运输类型的关系满足指定条件-->
                          <template v-if="['DISTRIBUTOR-DCCR-A008', 'DISTRIBUTOR-DWCR-A008'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                                <span class="blueColor cursor ml5">
                                  <span v-if="ruleItem.values[ruleItem.items[0].name] === '0'">{{ $t('key1001402') }} ） {{ $t('key1000189') }} {{ $t('key1001403') }}</span>
                                  <span v-else-if="ruleItem.values[ruleItem.items[0].name] === '1'">{{ $t('key1001404') }} ）</span>
                                  <span v-else>{{ ruleItem._guidanceText }}</span>
                                </span>
                              <template #content>
                                <div class="keywordString">
                                  <RadioGroup v-model="ruleItem.values[ruleItem.items[0].name]" @on-change="validRule(ruleItem.id)">
                                    <Radio label="0" style="marginTop:10px;">{{ $t('key1001402') }} ） {{ $t('key1000189') }} {{ $t('key1001403') }}</Radio>
                                    <br>
                                    <Radio label="1" style="marginTop:10px;">{{ $t('key1001404') }} ）</Radio>
                                  </RadioGroup>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单收件人电话要求指定条件-->
                          <template v-if="['DISTRIBUTOR-DCCR-A013','CORE-YCCR-011', 'DISTRIBUTOR-DWCR-A013'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                            <span class="blueColor cursor">
                              {{ $t('key1001405') }}
                            </span>
                              <template #content>
                                <div class="keywordString">
                                  <span>{{ $t('key1001406') }}</span>
                                  <div class="platformSelect normalTop">
                                    <Checkbox v-model="ruleItem.values['mobileLengthChecked']"></Checkbox>
                                    <span>{{ $t('key1001407') }}</span>
                                    <InputNumber
                                      :min="0"
                                      size="small"
                                      style="marginLeft:10px;"
                                      :disabled="!ruleItem.values['mobileLengthChecked']"
                                      v-model="ruleItem.values['mobileLength']"></InputNumber>
                                  </div>
                                  <Select
                                    v-model="ruleItem.values['phonePreRelateType']"
                                    style="width:120px;"
                                    size="small"
                                    :disabled="!ruleItem.values['phoneLengthChecked']">
                                    <Option v-for="ar in andOr" :value="ar.value">{{ ar.label }}</Option>
                                  </Select>
                                  <div class="platformSelect normalTop">
                                    <Checkbox v-model="ruleItem.values['phoneLengthChecked']"></Checkbox>
                                    <span>{{ $t('key1001408') }}</span>
                                    <InputNumber
                                      :min="0"
                                      size="small"
                                      style="marginLeft:10px;"
                                      :disabled="!ruleItem.values['phoneLengthChecked']"
                                      v-model="ruleItem.values['phoneLength']"></InputNumber>
                                  </div>
                                  <Select
                                    v-model="ruleItem.values['mobilePreRelateType']"
                                    style="width:120px;"
                                    size="small"
                                    :disabled="!ruleItem.values['mobilePreSlectChecked'] || (ruleItem.values['mobilePreSlectChecked'] && (!ruleItem.values['mobileLengthChecked'] && !ruleItem.values['phoneLengthChecked']))">
                                    <Option v-for="ar in andOr" :value="ar.value">{{ ar.label }}</Option>
                                  </Select>
                                  <div class="platformSelect normalTop">
                                    <Checkbox
                                      :disabled="!ruleItem.values['mobileLengthChecked']"
                                      v-model="ruleItem.values['mobilePreSlectChecked']"></Checkbox>
                                    <span> {{ $t('key1001409') }}</span>
                                    <Select
                                      v-model="ruleItem.values['mobilePreSlect']"
                                      style="width:120px;"
                                      size="small"
                                      :disabled="!ruleItem.values['mobilePreSlectChecked']">
                                      <Option v-for="ar in isBy" :value="ar.value">{{ ar.label }}</Option>
                                    </Select>
                                    <Input
                                      style="width:200px;marginLeft:10px;"
                                      type="textarea"
                                      :placeholder="$t('key1001344')"
                                      v-model.trim="ruleItem.values['mobilePres']"
                                      :disabled="!ruleItem.values['mobilePreSlectChecked']"></Input>
                                  </div>
                                </div>
                              </template>

                            </Poptip>
                          </template>
                          <!--收货地址街道包含指定字符串-->
                          <template v-if="['DISTRIBUTOR-DCCR-A009','DISTRIBUTOR-DWCR-A009','CORE-YCCR-007'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                              <span class="blueColor">
                                <span v-if="ruleItem.values['streets'] && ruleItem.values['streets'].length > 0  && ruleItem.values['streets'].some(i => i.value)">
                                  <span
                                    v-for="(item,index) in  ruleItem.values['streets']"
                                    :key="index"
                                    :title="JSON.stringify(ruleItem.values['streets'])"
                                    class="mr5 ellipsis_1">
                                    {{ item.value }}
                                  </span>
                                </span>
                                <span v-else>{{ $t('key1001410') }}</span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <p class="mb8">{{ $t('key1001411') }}</p>
                                  <Form
                                    ref="streets"
                                    class="reset-form"
                                    :model="ruleItem.values"
                                    :label-width="80"
                                    style="width: 300px">
                                    <FormItem v-for="(item, sIndex) in ruleItem.values['streets']" :key="sIndex" :label="$t('key1001341') + (sIndex + 1)">
                                      <Row>
                                        <Col span="18" offset="1">
                                          <Input type="text" clearable v-model.trim="item.value" :placeholder="$t('key1001345')"></Input>
                                        </Col>
                                        <Col span="4" offset="1">
                                          <Button @click="streetsRemove(index,sIndex)">{{ $t('key1000105') }}</Button>
                                        </Col>
                                      </Row>
                                    </FormItem>
                                    <FormItem>
                                      <Row>
                                        <Col span="12">
                                          <Button type="dashed" long @click="streetsAdd(index)" icon="md-add">{{ $t('key1001340') }}</Button>
                                        </Col>
                                      </Row>
                                    </FormItem>
                                  </Form>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单发货仓为：指定字符串-->
                          <template v-if="['DISTRIBUTOR-DWCR-A029'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                              <span class="blueColor">
                                <span v-if="ruleItem.values['warehouseNames'] && ruleItem.values['warehouseNames'].length > 0  && ruleItem.values['warehouseNames'].some(i => i.value)">
                                  <span
                                    v-for="(item,index) in  ruleItem.values['warehouseNames']"
                                    :key="index"
                                    :title="JSON.stringify(ruleItem.values['warehouseNames'])"
                                    class="mr5 ellipsis_1">
                                    {{ item.value }}
                                  </span>
                                </span>
                                <span v-else>{{ $t('key1001410') }}</span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <p class="mb8">{{ $t('key1001412') }}</p>
                                  <Form
                                    ref="warehouseNames"
                                    class="reset-form"
                                    :model="ruleItem.values"
                                    :label-width="80"
                                    style="width: 300px">
                                    <FormItem v-for="(item, sIndex) in ruleItem.values['warehouseNames']" :key="sIndex" :label="$t('key1001342') + (sIndex + 1)">
                                      <Row>
                                        <Col span="18" offset="1">
                                          <Input type="text" clearable v-model.trim="item.value" :placeholder="$t('key1001345')"></Input>
                                        </Col>
                                        <Col span="4" offset="1">
                                          <Button @click="warehouseNamesRemove(index,sIndex)">{{ $t('key1000105') }}</Button>
                                        </Col>
                                      </Row>
                                    </FormItem>
                                    <FormItem>
                                      <Row>
                                        <Col span="12">
                                          <Button type="dashed" long @click="warehouseNamesAdd(index)" icon="md-add">{{ $t('key1001340') }}</Button>
                                        </Col>
                                      </Row>
                                    </FormItem>
                                  </Form>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单收货地址街道信息字符长度小于指定长度-->
                          <template v-if="['DISTRIBUTOR-DCCR-A010','DISTRIBUTOR-DWCR-A010','CORE-YCCR-008'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                            <span class="blueColor cursor">
                              {{ $t('key1001413') }}
                            </span>
                              <span>{{ ruleItem.values['length'] }}</span>
                              <template #content>
                                <div class="keywordString">
                                  <span>{{ $t('key1001414') }}</span>
                                  <InputNumber
                                    :min="0"
                                    size="small"
                                    style="marginLeft:10px;"
                                    v-model="ruleItem.values['length']"></InputNumber>
                                  <div style="color: red;marginTop: 5px;">
                                    {{ $t('key1001415') }}
                                  </div>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单收货邮编指定格式-->
                          <template v-if="['DISTRIBUTOR-DCCR-A011','DISTRIBUTOR-DWCR-A011','CORE-YCCR-009'].includes(ruleItem.id)">
                            <Poptip transfer width="650" placement="bottom">
                              <span class="blueColor cursor">
                                <span v-if="(ruleItem.values['beginStrChecked'] && ruleItem.values['beginStr']) || (ruleItem.values['containsStrChecked'] && ruleItem.values['containsStr'])">
                                  <span v-if="ruleItem.values['beginStrChecked']">{{ $t('key1000190') }} <span class="plr10">{{ ruleItem.values['beginStr'] }}</span> {{ $t('key1001366') }}</span>
                                  <span v-if="ruleItem.values['beginStrChecked'] && ruleItem.values['containsStrChecked']">
                                    <span v-if="ruleItem.values['relevance'] === 0">{{ $t('key1001416') }}</span>
                                    <span v-if="ruleItem.values['relevance'] === 1">{{ $t('key1001417') }}</span>
                                  </span>
                                  <span v-if="ruleItem.values['containsStrChecked']">
                                    {{ $t('key1001418') }}
                                    <span class="plr10">{{ ruleItem.values['containsStr'] }}</span>
                                  </span>
                                </span>
                                <span v-else>{{ $t('key1001419') }}</span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <span>{{ $t('key1001420') }}</span>
                                  <div class="platformSelect normalTop">
                                    <Checkbox v-model="ruleItem.values['beginStrChecked']">{{ $t('key1000190') }}</Checkbox>
                                    <Input
                                      style="width:200px;marginLeft:10px;"
                                      type="textarea"
                                      :placeholder="$t('key1001344')"
                                      v-model.trim="ruleItem.values['beginStr']"
                                      :disabled="!ruleItem.values['beginStrChecked']"></Input>
                                    {{ $t('key1001366') }}
                                  </div>
                                  <Select
                                    v-model="ruleItem.values['relevance']"
                                    style="width:80px;marginTop:15px;"
                                    size="small"
                                    :disabled="!(ruleItem.values['beginStrChecked'] && ruleItem.values['containsStrChecked'])">
                                    <Option :value="'0'">{{ $t('key1000188') }}</Option>
                                    <Option :value="'1'">{{ $t('key1000189') }}</Option>
                                  </Select>
                                  <div class="platformSelect normalTop">
                                    <Checkbox v-model="ruleItem.values['containsStrChecked']">{{ $t('key1001418') }}</Checkbox>
                                    <Input
                                      style="width:200px;marginLeft:10px;"
                                      type="textarea"
                                      :placeholder="$t('key1001344')"
                                      v-model.trim="ruleItem.values['containsStr']"
                                      :disabled="!ruleItem.values['containsStrChecked']"></Input>
                                  </div>
                                </div>
                              </template>

                            </Poptip>
                          </template>
                          <!--订单收件人姓名/地址存在指定异常-->
                          <template v-if="['DISTRIBUTOR-DCCR-A014','CORE-YCCR-012', 'DISTRIBUTOR-DWCR-A014'].includes(ruleItem.id)">
                            <span class="blueColor cursor" @click="$refs.ruleTempAbnormal.open(ruleItem.values,ruleItem.id)">{{ $t('key1001421') }}</span>
                          </template>
                          <!--订单目的地为指定国家/邮编范围-->
                          <template v-if="['CORE-YPDR-004','CORE-YCCR-002','DISTRIBUTOR-DCCR-A003', 'DISTRIBUTOR-DWCR-A003'].includes(ruleItem.id)">
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor countryCodesName"
                              @click="editOperation(index,0)">
                              {{ countryCodesName === '' ? $t('key1000197') : countryCodesName }}
                            </span>
                            <vueTreeSelect
                              v-else
                              :clearable="true"
                              :searchable="true"
                              :multiple="true"
                              :noResultsText="$t('key1000102')"
                              :noOptionsText="$t('key1000375')"
                              :placeholder="$t('key1000101')"
                              :normalizer="normalizerData"
                              :options="ruleCountryData"
                              v-model="countryCodes"
                              :defaultExpandLevel="1"
                              @input="(data, item) => selectRuleCountry(data,item, ruleItem.id)"
                              class="reset_vueTreeselect_style"
                            />
                            <!-- 且邮编在 -->
                            <span
                              v-if="ruleItem.id !== 'CORE-YPDR-004'"
                              class="itemPaddingRight"
                              :class="{textMarginTop: ruleItem.values['countryCodes']}">{{ $t('key1001422') }}</span>
                            <span
                              v-if="ruleItem.id !== 'CORE-YPDR-004'"
                              class="blueColor itemPaddingRight cursor"
                              :class="{textMarginTop: ruleItem.items[0]._isOperation}">
                              <Poptip
                                transfer
                                width="500"
                                placement="bottom">
                                <!-- 指定范围 -->
                                <span class="blueColor itemPaddingRight cursor" v-if="ruleItem.values['postalCodeType'] === '0'">
                                  <span v-for="(item, index) in postcodeArr" :key="index">
                                    <span v-if="index > 0">, </span>
                                    {{
                                      item.postcode1 !== '' && item.postcode2 !== ''
                                        ? item.postcode1 + '-' + item.postcode2
                                        : postcodeArea !== '' ? postcodeArea : $t('key1001364')
                                    }}
                                  </span>
                                </span>
                                <span v-else>
                                    {{ postcodeArea ? postcodeArea : $t('key1001364') }}
                                </span>
                                <template #content>
                                  <div class="keywordString">
                                  <RadioGroup
                                    v-model="ruleItem.values['postalCodeType']"
                                    @on-change="getPostCodeType">
                                    <!-- 邮编段 -->
                                    <Radio :label="'0'">
                                      <span>{{ $t('key1001423') }}</span>
                                    </Radio>
                                    <!-- 邮编列表 -->
                                    <Radio :label="'1'">
                                      <span>{{ $t('key1001424') }}</span>
                                    </Radio>
                                  </RadioGroup>
                                    <!-- 邮编段 -->
                                  <div class="normalTop" v-if="ruleItem.values['postalCodeType'] === '0'">
                                    <!-- <Input v-model.trim="postcodeOne" style="width:150px"></Input>
                                    <span> - </span>
                                    <Input v-model.trim="postcodeTwo" style="width:150px"></Input> -->
                                    <div v-for="(item, index) in postcodeArr" :key="index" class="normalMarginBottom">
                                      <Input clearable v-model.trim="item.postcode1" style="width:150px"></Input>
                                      <span> - </span>
                                      <Input clearable v-model.trim="item.postcode2" style="width:150px"></Input>
                                      <Button
                                        type="primary"
                                        shape="circle"
                                        icon="md-add"
                                        class="normalLMargin"
                                        v-if="index === 0"
                                        @click="addPostcodeFn"></Button>
                                      <Button
                                        type="error"
                                        shape="circle"
                                        icon="md-remove"
                                        class="normalLMargin"
                                        v-if="index > 0"
                                        @click="deletePostcodeFn(index)"></Button>
                                    </div>
                                  </div>
                                    <!-- 邮编列表 -->
                                  <div class="normalTop" v-if="ruleItem.values['postalCodeType'] === '1'">
                                    <Input
                                      v-model="postcodeArea"
                                      style="width:300px"
                                      type="textarea"
                                      :rows="5"
                                      :placeholder="$t('key1001346')"></Input>
                                  </div>
                                </div>
                                </template>

                              </Poptip>
                            </span>
                          </template>
                          <!--买家选择的运输类型为指定类型-->
                          <template v-if="['DISTRIBUTOR-DCCR-A002','DISTRIBUTOR-DWCR-A002'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="700"
                              placement="right">
                              <span class="blueColor cursor max-height-300">
                              {{ shipmentTagModel.length > 0 ? '' : $t('key1001365') }}
                              <span
                                v-show="shipmentTagModel.length > 0"
                                class="mr20"
                                v-for="(item,index) in shipmentTagModel"
                                :key="index">{{ item }}</span></span>
                              <template #content>
                                <div class="keywordString">
                                  <div>
                                    {{ $t('key1001425') }}
                                  </div>
                                  <div class="breakWord max-height-300">
                                    <Tag
                                      closable
                                      :color="tagColor(item)"
                                      v-for="(item, index) in shipmentTagModel"
                                      :key="index"
                                      @on-close="delTag(index)">{{ item }}</Tag>
                                  </div>
                                  <div class="divider normalTop"></div>
                                  <div class="platformSelect normalTop">
                                    <Select
                                      v-model="shipmentPlatformModel"
                                      style="width:150px"
                                      @on-change="getSite"
                                      filterable
                                      :placeholder="$t('key1001347')">
                                      <Option
                                        v-for="item in shipmentPlatformList.filter((ele) => !['temu', 'temu_choice'].includes(ele.platformId))"
                                        :key="item.platformId"
                                        :value="item.platformId">{{ item.name }}</Option>
                                    </Select>
                                    <Select
                                      v-model="shipmentPlatformSite"
                                      v-if="hasSite"
                                      filterable
                                      style="width:150px; margin-left:10px"
                                      @on-change="setSite">
                                      <Option
                                        v-for="item in shipmentPlatformSiteList"
                                        :key="item.siteId"
                                        :value="item.siteId">{{ item.cnName }}</Option>
                                    </Select>
                                  </div>
                                  <div class="normalTop">
                                    <Input
                                      v-model.trim="shipmentSearchValue"
                                      style="width:310px"
                                      @on-enter="shipmentSearch"
                                      :placeholder="$t('key1001348')"/>
                                  </div>
                                  <div class="normalTop" v-if="shipmentPlatformModel === 'shopify'">
                                    <Input
                                      v-model.trim='shippingMethodName'
                                      :placeholder="$t('key1001349')"
                                      style="width:310px;margin-right:10px"/><Button @click='saveShopifyLogisticsMode'>{{ $t('key1000555') }}</Button>
                                  </div>
                                  <div class="normalTop" v-if="shipmentPlatformModel !== '' && smShippingMethodList.length > 0">
                                    <CheckboxGroup v-model="shipmentCheckBoxModel" @on-change="setTagValue">
                                      <div class="checkboxContainer">
                                        <div class="normalTop" v-for="(item, index) in smShippingMethodList" :key="index">
                                          <Checkbox
                                            v-if="item.siteId"
                                            :label="shipmentPlatformModel + ':' +item.siteId + ':' +item.siteName + ':'+ item.shippingMethodName + ':' + item.shippingMethodDescription">{{ item.shippingMethodDescription }}
                                          </Checkbox>
                                          <Checkbox
                                            v-else
                                            :label="shipmentPlatformModel + ':' + item.shippingMethodName + ':' + item.shippingMethodDescription">
                                            <span>{{ item.shippingMethodDescription }}</span>
                                          </Checkbox>
                                          <!--您确定要删除吗-->
                                          <Poptip
                                            confirm
                                            :title="$t('key1001350')"
                                            @on-ok="deleteShipMethod(item.merchantShippingMethodId,index)">
                                            <Icon type="ios-close-circle" v-if="shipmentPlatformModel === 'shopify'"/>
                                          </Poptip>
                                        </div>
                                      </div>
                                    </CheckboxGroup>
                                  </div>
                                </div>
                              </template>

                            </Poptip>
                          </template>
                          <!--订单总金额指定范围-->
                          <template v-if="['DISTRIBUTOR-DCCR-A006','DISTRIBUTOR-DWCR-A006','CORE-YCCR-005'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                              <span class="blueColor cursor">
                                <span class="ml10" v-if="amountRange.usdFloor !== 0 || amountRange.usdUpper !== 0">
                                  {{ amountRange.usdFloor + '-' + amountRange.usdUpper }}(USD)
                                </span>
                                <span class="ml10" v-if="amountRange.eurFloor !== 0 || amountRange.eurUpper !== 0">
                                  {{ amountRange.eurFloor + '-' + amountRange.eurUpper }}(EUR)
                                </span>
                                <span class="ml10" v-if="amountRange.gbpFloor !== 0 || amountRange.gbpUpper !== 0">
                                  {{ amountRange.gbpFloor + '-' + amountRange.gbpUpper }}(GBP)
                                </span>
                                <span class="ml10" v-if="amountRange.audFloor !== 0 || amountRange.audUpper !== 0">
                                  {{ amountRange.audFloor + '-' + amountRange.audUpper }}(AUD)
                                </span>
                                <span class="ml10" v-if="amountRange.cnyFloor !== 0 || amountRange.cnyUpper !== 0">
                                  {{ amountRange.cnyFloor + '-' + amountRange.cnyUpper }}(CNY)
                                </span>
                                <span
                                  v-if="amountRange.usdUpper === 0 && amountRange.eurUpper === 0 &&
                                 amountRange.gbpUpper === 0 && amountRange.audUpper === 0 &&
                                 amountRange.cnyUpper === 0">{{ $t('key1001364') }}
                                </span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <Form ref="amountRange" :model="amountRange" :label-width="80" @submit.native.prevent>
                                    <FormItem :label="$t('key1001351')">
                                      <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.usdFloor"></InputNumber>
                                      <span> - </span>
                                      <InputNumber style="width:80px;" :min="0" v-model="amountRange.usdUpper" @on-blur="setNumber(1)"></InputNumber>
                                    </FormItem>
                                    <FormItem :label="$t('key1001352')">
                                      <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.eurFloor"></InputNumber>
                                      <span> - </span>
                                      <InputNumber style="width:80px;" :min="0" @on-blur="setNumber(2)" v-model="amountRange.eurUpper"></InputNumber>
                                    </FormItem>
                                    <FormItem :label="$t('key1001353')">
                                      <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.gbpFloor"></InputNumber>
                                      <span> - </span>
                                      <InputNumber style="width:80px;" :min="0" @on-blur="setNumber(3)" v-model="amountRange.gbpUpper"></InputNumber>
                                    </FormItem>
                                    <FormItem :label="$t('key1001354')">
                                      <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.audFloor"></InputNumber>
                                      <span> - </span>
                                      <InputNumber style="width:80px" :min="0" @on-blur="setNumber(4)" v-model="amountRange.audUpper"></InputNumber>
                                    </FormItem>
                                    <FormItem :label="$t('key1001355')">
                                      <InputNumber style="width:80px; margin-left: 5px;" :min="0" v-model="amountRange.cnyFloor"></InputNumber>
                                      <span> - </span>
                                      <InputNumber style="width:80px" :min="0" @on-blur="setNumber(5)" v-model="amountRange.cnyUpper"></InputNumber>
                                    </FormItem>
                                  </Form>
                                  <div class="redColor">{{ $t('key1001426') }}</div>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--买家支付的运费指定范围-->
                          <template v-if="['DISTRIBUTOR-DCCR-A015','DISTRIBUTOR-DWCR-A015','CORE-YCCR-021'].includes(ruleItem.id)">
                            <Poptip transfer width="500" placement="bottom">
                              <span class="blueColor cursor">
                                <span v-if="ruleItem.values['currency']">
                                  <span class="cpd" v-if="ruleItem.values['beginValue'] !== 0 && ruleItem.values['beginChecked']">
                                    <span v-if="ruleItem.values['beginType'] === '0'">&ge;</span>
                                    <span v-else-if="ruleItem.values['beginType'] === '1'">&gt;</span>
                                    <span v-else>=</span>{{ ruleItem.values['beginValue'] }}  {{ ruleItem.values['currency'] }}
                                  </span>
                                  <span class="cpd" v-if="ruleItem.values['endValue'] !== 0 && ruleItem.values['endChecked']">
                                    <span v-if="ruleItem.values['endType'] === '0'">&lt;</span>
                                    <span v-else-if="ruleItem.values['endType'] === '1'">&le;</span>
                                    <span>{{ ruleItem.values['endValue'] }}  {{ ruleItem.values['currency'] }}</span>
                                  </span>
                                </span>
                                <span v-if="!(ruleItem.values['currency']) || (!(ruleItem.values['beginValue'] !== 0 && ruleItem.values['beginChecked']) && !(ruleItem.values['endValue'] !== 0 && ruleItem.values['beginChecked']))">{{ $t('key1001364') }}</span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <span>{{ $t('key1001427') }}</span>
                                  <Select
                                    v-model="ruleItem.values['currency']"
                                    style="width: 150px"
                                    filterable
                                    size="small">
                                    <Option
                                      v-for="(item, index) in currencyList"
                                      :key="index"
                                      :value="item.value">{{ item.label }}</Option>
                                  </Select>
                                  <span style="marginLeft:10px;">{{ $t('key1001428') }}</span>
                                  <div class="platformSelect normalTop">
                                    <Checkbox v-model="ruleItem.values['beginChecked']"></Checkbox>
                                    <Select
                                      v-model="ruleItem.values['beginType']"
                                      style="width:120px;"
                                      size="small"
                                      :disabled="!ruleItem.values['beginChecked']">
                                      <Option :value="'0'">&ge;</Option>
                                      <Option :value="'1'">&gt;</Option>
                                      <Option :value="'2'">=</Option>
                                    </Select>
                                    <InputNumber
                                      :min="0"
                                      size="small"
                                      style="marginLeft:10px;"
                                      :disabled="!ruleItem.values['beginChecked']"
                                      v-model="ruleItem.values['beginValue']"></InputNumber>
                                  </div>
                                  <div class="platformSelect normalTop">
                                    <Checkbox v-model="ruleItem.values['endChecked']"></Checkbox>
                                    <Select
                                      v-model="ruleItem.values['endType']"
                                      style="width:120px;"
                                      size="small"
                                      :disabled="!ruleItem.values['endChecked']">
                                      <Option :value="'0'">&lt;</Option>
                                      <Option :value="'1'">&le;</Option>
                                    </Select>
                                    <InputNumber
                                      :min="0"
                                      size="small"
                                      style="marginLeft:10px;"
                                      :disabled="!ruleItem.values['endChecked']"
                                      v-model="ruleItem.values['endValue']"></InputNumber>
                                  </div>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单产品店铺SKU包含指定规律-->
                          <template v-if="['order-service-A034','DISTRIBUTOR-DCCR-A026','DISTRIBUTOR-DWCR-A026'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="500"
                              placement="bottom">
                              <span class="blueColor cursor">
                                {{
                                  shopSkuModel === 0 ? $t('key1000190') + shopSku.start + $t('key1001366') : shopSkuModel === 1
                                    ? $t('key1000190') + shopSku.end + $t('key1001367')
                                    : $t('key1001368')
                                }}
                              </span>
                              <template #content>
                                <div class="keywordString shopSku">
                                  <RadioGroup v-model="shopSkuModel" vertical>
                                    <Radio :label="0">
                                      {{ $t('key1000190') }} <Input v-model.trim="shopSku.start" style="width:160px" clearable></Input> {{ $t('key1001366') }}
                                    </Radio>
                                    <Radio :label="1" style="margin-top:10px">
                                      {{ $t('key1000190') }} <Input v-model.trim="shopSku.end" clearable style="width:160px"></Input> {{ $t('key1001367') }}
                                    </Radio>
                                  </RadioGroup>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单产品包含SKU-->
                          <template v-if="['DISTRIBUTOR-DCCR-A027','DISTRIBUTOR-DWCR-A027','CORE-YCCR-022'].includes(ruleItem.id)">
                            <Poptip
                              transfer
                              width="350"
                              placement="bottom">
                              <span class="blueColor cursor">
                                {{
                                  ruleItem.values['skus'] && ruleItem.values['skus'].length > 0
                                    ? ruleItem.values['skus'].toString()
                                    : $t('key1001369')
                                }}
                              </span>
                              <template #content>
                                <div>
                                  <Input
                                    v-model.trim="ruleItem.values['skus']"
                                    type="textarea"
                                    :rows="4"
                                    style="width:300px"
                                    :placeholder="$t('key1001356')">
                                  </Input>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单货品状态包含指定的商品状态指定的商品状态-->
                          <template v-if="['DISTRIBUTOR-DCCR-A023','DISTRIBUTOR-DWCR-A023','CORE-YCCR-020'].includes(ruleItem.id)">
                            <span
                              class="blueColor itemPaddingRight cursor"
                              v-if="!ruleItem.items[0]._isOperation"
                              @click="editOperation(index,0)">
                              <span v-if="ruleItem.values['productStatus'] && ruleItem.values['productStatus'].length">
                                <span v-if="ruleItem.values['productStatus'].includes('0')">{{ $t('key1000539') }}</span>
                                <span v-if="ruleItem.values['productStatus'].includes('1')">{{ $t('key1001112') }}</span>
                                <span v-if="ruleItem.values['productStatus'].includes('2')">{{ $t('key1001113') }}</span>
                                <span v-if="ruleItem.values['productStatus'].includes('3')">{{ $t('key1001114') }}</span>
                              </span>
                              <span v-else>{{ $t('key1001429') }}</span>
                            </span>
                            <Select
                              v-else
                              v-model="ruleItem.values['productStatus']"
                              multiple
                              style="width: 200px">
                              <Option :value="'0'">{{ $t('key1000539') }}</Option>
                              <Option :value="'1'">{{ $t('key1001112') }}</Option>
                              <Option :value="'2'">{{ $t('key1001113') }}</Option>
                              <Option :value="'3'">{{ $t('key1001114') }}</Option>
                            </Select>
                          </template>
                          <!--订单发货仓库为指定仓库-->
                          <template v-if="['CORE-YCCR-023','CORE-YPDR-002'].includes(ruleItem.id)">
                              <span
                                v-if="!ruleItem.items[0]._isOperation"
                                class="blueColor itemPaddingRight cursor"
                                @click="editOperation(index,0)">
                              {{ !(ruleItem.values['warehouseIds'] && ruleItem.values['warehouseIds'].length) ? $t('key1001370') : ymsWarehouseList.filter(j => ruleItem.values['warehouseIds'].includes(j.ymsWarehouseId)).map(i => i.name).join(' ') }}
                            </span>
                            <Select v-else v-model="ruleItem.values['warehouseIds']" multiple style="width: 200px" filterable>
                              <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
                            </Select>
                          </template>
                          <!--<template v-if="ruleItem.id === 'CORE-YPDR-011'">
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)" >
                    {{
                                ruleItem.values['productTags'] && ruleItem.values['productTags'].length > 0
                                  ? ruleItem.values['productTags'].join('或')
                                  : '指定的商品标签'
                              }}
                  </span > <Select
                            v-else
                            v-model="ruleItem.values['productTags']"
                            style="width:256px"
                            multiple > <Option
                            v-for="(item, index) in productTagList" :key="index" :value="item.name" >{{ item.name }} </Option >
                          </Select >
                          </template>-->
                          <!--订单来源-->
                          <template v-if="['CORE-YPDR-001','CORE-YCCR-001'].includes(ruleItem.id)">
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)">
                            {{
                                ruleItem.values['platformIds'] && ruleItem.values['platformIds'].length > 0
                                  ? ruleItem.values['platformIds'].join($t('key1001371'))
                                  : $t('key1001372')
                              }}
                            </span>
                            <Select
                              v-else
                              v-model="ruleItem.values['platformIds']"
                              style="width:256px"
                              filterable
                              multiple><Option
                              v-for="item in shipmentPlatformList"
                              :value="item.platformId"
                              :key="item.platformId"> {{ item.name }} </Option>
                            </Select>
                          </template>
                          <!--订单来源为指定平台/站点/账号-->
                          <template v-if="['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(ruleItem.id)">
                            <span v-if="!ruleItem.items[0]._isOperation" class="blueColor itemPaddingRight cursor" @click="editOperation(index,0)">
                              {{
                                ruleItem.values['platformIds'] && ruleItem.values['platformIds'].length > 0
                                  ? ruleItem.values['platformIds'].join($t('key1001371')) : $t('key1001372')
                              }}
                            </span>
                            <Select v-else v-model="ruleItem.values['platformIds']" @on-change="changeDisPlatformId(ruleItem)"
                              style="width:150px" filterable multiple>
                              <Option v-for="item in basicPlatform" :value="item.platformId" :key="item.platformId">{{ item.name }}</Option>
                            </Select>
                            <span class="itemPaddingRight" :class="{textMarginTop: ruleItem.values['platformIds']}">{{ $t('key1001430') }}</span>
                            <span class="blueColor itemPaddingRight cursor" :class="{textMarginTop: ruleItem.values['platformIds']}"
                              @click="editOperation(index,1)" v-if="!ruleItem.items[1]._isOperation">{{ siteIdName }}</span>
                            <Select v-else style="width: 160px" v-model="ruleItem.values['siteIds']" filterable multiple :placeholder="$t('key1001357')">
                              <Option v-for="(item, index) in disSites" :key="index" :value="item.siteId" :v="item.cnName">{{ item.cnName }}</Option>
                            </Select>
                            <span class="itemPaddingRight" :class="{textMarginTop: ruleItem.values['platformIds']}">{{ $t('key1001430') }}</span>
                            <span class="blueColor itemPaddingRight cursor" :class="{textMarginTop: ruleItem.values['platformIds']}"
                              v-if="!ruleItem.items[2]._isOperation" @click="editOperation(index,2)">
                              {{ saleAccountName ? saleAccountName : $t('key1000187') }}
                            </span>
                            <Select v-else v-model="ruleItem.values['saleAccountIds']" filterable multiple :placeholder="$t('key1001358')" style="width: 100px">
                              <Option
                                v-for="(item, index) in platformAccountList"
                                :key="index"
                                :value="item.ymsPlatformAccountId" :label="item.code">
                              </Option>
                            </Select>
                          </template>
                          <!--包裹货品指定货品-->
                          <template v-if="ruleItem.id === 'CORE-YPDR-007'">
                            <Poptip transfer width="500" placement="bottom">
                              <span class="blueColor cursor">
                                <span class="mr10" v-if="productGoodsIds && productGoodsIds.length > 0 ">{{ productGoodsIds }}</span>
                                <span v-else>{{ $t('key1001431') }}</span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <span>{{ $t('key1001390') }}</span>
                                  <Input
                                    style="width:200px;marginLeft:10px;"
                                    type="textarea"
                                    :placeholder="$t('key1001344')"
                                    v-model.trim="productGoodsIds"></Input>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单产品包含指定分类/SKU-->
                          <template v-if="['CORE-YPDR-010','CORE-YCCR-006','DISTRIBUTOR-DCCR-A007','DISTRIBUTOR-DWCR-A007'].includes(ruleItem.id)">{{ ruleItem.values['ymsProductCategoryId'] }}
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)">
                            {{ ruleItem.values['productCategories'] && ruleItem.values['productCategories'].length > 0 ? productCategoryListName : $t('key1000198') }}
                           </span>
                            <vueTreeSelect
                              v-else
                              v-model="ruleItem.values['productCategories']"
                              :clearable="true"
                              :searchable="true"
                              :openOnFocus="true"
                              :closeOnSelect="true"
                              :multiple="true"
                              :noResultsText="$t('key1000102')"
                              :noOptionsText="$t('key1000375')"
                              :placeholder="$t('key1000101')"
                              :normalizer="normalizer"
                              :options="ymsProductCategoryList">
                              <template #option-label="{ node, labelClassName }">
                                <label
                                  :class="labelClassName"
                                  :title="node.label">
                                  {{ node.label }}
                                </label>
                              </template>
                            </vueTreeSelect>
                            <span class="itemPaddingRight">{{ $t('key1001371') }}</span>
                            <Poptip transfer width="350" placement="bottom">
                              <span class="blueColor cursor">
                                {{ ruleItem.values['skus'] && ruleItem.values['skus'].length > 0 ? ruleItem.values['skus'].toString() : $t('key1001369') }}
                              </span>
                              <template #content>
                                <Input
                                  v-model.trim="ruleItem.values['skus']"
                                  type="textarea"
                                  :rows="4"
                                  style="width:300px"
                                  :placeholder="$t('key1001356')">
                                </Input>
                              </template>
                            </Poptip>
                          </template>
                          <!--指定邮寄方式-->
                          <template v-if="['CORE-YPDR-003'].includes(ruleItem.id)">
                            <Poptip>
                            <span class="blueColor itemPaddingRight cursor">
                              <span v-if="shippingParmas.length > 0">
                                <span
                                  class="mr10"
                                  v-for="(item,index) in shippingParmas"
                                  :key="index">{{ item.name }}</span>
                              </span>
                              <span v-if="shippingParmas.length === 0">{{ $t('key1001432') }}</span>
                              </span>
                              <template #content>
                                <div>
                                  <div style="display: inline-block;width: 300px;">
                                    <Cascader
                                      :data="shippingMethodData"
                                      @on-visible-change="showShippingDataApi"
                                      v-model="value2"
                                      :load-data="loadDataApi"
                                      @on-change="getAccountApi"></Cascader>
                                  </div>
                                  <div style="padding: 10px;">
                                    {{ $t('key1001123') }}
                                    <p v-for="(item,index) in shippingParmas" :key="index">
                                      <Tag closable @on-close="handleClose(index)">{{ item.name }}
                                      </Tag>
                                    </p>
                                  </div>
                                </div>
                              </template>

                            </Poptip>
                          </template>
                          <!--订单基础物流为指定基础物流-->
                          <template v-if="ruleItem.id === 'CORE-YPDR-011'">
                            <Select style="width: 200px;"
                              filterable
                              multiple
                              :placeholder="$t('key1001359')"
                              v-if="ruleItem.items[0]._isOperation"
                              v-model="ruleItem.values['shippingMethodIds']">
                              <Option v-for="yun in yunShipList" :value="yun.ymsLogisServiceId">{{ yun.name }}</Option>
                            </Select>
                            <span v-else class="blueColor" @click="editOperation(index,0)">{{ yunWarehouseName }}</span>
                          </template>
                          <!--订单总金额为-->
                          <template v-if="['CORE-YPDR-005'].includes(ruleItem.id)">
                            <Poptip transfer width="500" placement="bottom">
                              <span class="blueColor cursor">
                                {{ totalPrices['currency'] ? totalPrices['beginValue'] + '-' + totalPrices['endValue'] + '(' + totalPrices['currency'] + ')' : $t('key1001364') }}
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <Alert class="key-alert">{{ $t('key1001433') }}</Alert>
                                  <span>
                                    {{ $t('key1001434') }}
                                    <Select style="width: 200px;" size="small" filterable v-model="totalPrices['currency']">
                                      <Option
                                        v-for="(item, index) in currencyList"
                                        :key="index"
                                        :value="item.value">{{ item.label }}
                                      </Option>
                                    </Select>{{ $t('key1001428') }}
                                  </span>
                                  <div class="mt10">
                                    <InputNumber :min="0" size="small" style="marginLeft:10px;" v-model="totalPrices['beginValue']"></InputNumber>
                                    -
                                    <InputNumber :min="0" size="small" style="marginLeft:10px;" v-model="totalPrices['endValue']"></InputNumber>
                                  </div>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--订单买家ID包含指定字符串-->
                          <template v-if="['CORE-YCCR-021','DISTRIBUTOR-DCCR-A025','DISTRIBUTOR-DWCR-A025'].includes(ruleItem.id)">
                            <Poptip transfer width="500" placement="bottom">
                              <span class="blueColor">
                                <span v-if="ruleItem.values['containsStr'] && ruleItem.values['containsStr'].length > 1 && ruleItem.values['containsStr'].value !== ''"><span
                                  v-for="(item,index) in ruleItem.values['containsStr']" :key="index">
                                  {{ item.value }}
                                </span>
                                </span>
                              <span v-else>{{ $t('key1001410') }}</span>
                              </span>
                              <template #content>
                                <div class="keywordString">
                                  <span>{{ $t('key1001435') }}</span>
                                  <Form ref="containsStr" :label-width="80" style="width: 300px">
                                    <FormItem
                                      v-for="(item, index) in ruleItem.values['containsStr']"
                                      :key="index"
                                      :label="$t('key1001341') + index">
                                      <Row>
                                        <Col span="18">
                                          <Input type="text" clearable v-model.trim="item.value" :placeholder="$t('key1001345')"></Input>
                                        </Col>
                                        <Col span="4" offset="1">
                                          <Button @click="orderStrRemove(index,ruleItem.id)">{{ $t('key1000105') }}</Button>
                                        </Col>
                                      </Row>
                                    </FormItem>
                                    <FormItem>
                                      <Row>
                                        <Col span="12">
                                          <Button type="dashed" long @click="orderStrAdd(ruleItem.id)" icon="md-add">{{ $t('key1001340') }}</Button>
                                        </Col>
                                      </Row>
                                    </FormItem>
                                  </Form>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!---------------商品销售价配置规则项------------------->
                          <!--商品的分类为：指定分类-->
                          <template v-if="['CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'].includes(ruleItem.id)">{{ ruleItem.values['ymsProductCategoryId'] }}
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)">
                            {{ ruleItem.values['productCategories'] && ruleItem.values['productCategories'].length > 0 ? productCategoryListName : $t('key1000198') }}
                           </span>
                            <vueTreeSelect
                              v-else
                              v-model="ruleItem.values['productCategories']"
                              :clearable="true"
                              :searchable="true"
                              :openOnFocus="true"
                              :closeOnSelect="true"
                              :multiple="true"
                              :noResultsText="$t('key1000102')"
                              :noOptionsText="$t('key1000375')"
                              :placeholder="$t('key1000101')"
                              :normalizer="normalizer"
                              :options="ymsProductCategoryList">
                              <template #option-label="{ node, labelClassName }">
                                <label
                                  :class="labelClassName"
                                  :title="node.label">
                                  {{ node.label }}
                                </label>
                              </template>
                            </vueTreeSelect>
                          </template>
                          <!--商品的发货仓/发货地为：指定发货地 指定发货仓-->
                          <template v-if="['CORE-YPPCR-003', 'CORE-YPPMR-003', 'CORE-YPPSCR-003', 'CORE-YPPSMR-003'].includes(ruleItem.id)">
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)">
                              {{
                                !(ruleItem.values['ymsDeliveryPlaceIds'] && ruleItem.values['ymsDeliveryPlaceIds'].length) ? $t('key1001373') :
                                  placeOfShipmentList.filter(j => ruleItem.values['ymsDeliveryPlaceIds'].includes(j.ymsDeliveryPlaceId)).map(i => i.deliveryPlaceName).join('、')
                              }}
                            </span>
                            <Select v-else v-model="ruleItem.values['ymsDeliveryPlaceIds']" multiple style="width: 200px" filterable
                              @on-change="(value) => selectYmsDeliveryPlace(value, index)">
                              <Option v-for="item in placeOfShipmentList" :key="item.ymsDeliveryPlaceId" :value="item.ymsDeliveryPlaceId">{{ item.deliveryPlaceName }}</Option>
                            </Select>
                            <span v-if="ruleItem._prefixTextList" class="ml10">{{ ruleItem._prefixTextList[1] }}</span>
                            <span
                              v-if="!ruleItem.items[1]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,1)">
                            {{
                                !(ruleItem.values['ymsWarehouseIds'] && ruleItem.values['ymsWarehouseIds'].length) ? $t('key1001374') :
                                  shippingWarehouseList.filter(j => ruleItem.values['ymsWarehouseIds'].includes(j.ymsWarehouseId)).map(i => i.name).join('、')
                              }}
                          </span>
                            <Select class="ml10" v-else v-model="ruleItem.values['ymsWarehouseIds']" multiple style="width: 200px" filterable>
                              <Option v-for="item in shippingWarehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
                            </Select>
                          </template>
                          <!--商品的SPU为：指定SPU-->
                          <template v-if="['CORE-YPPCR-004','CORE-YPPMR-004','CORE-YPPSCR-004','CORE-YPPSMR-004'].includes(ruleItem.id)">
                            <Poptip transfer width="450" placement="bottom">
                              <span class="blueColor cursor">
                                {{ formatListValue(ruleItem.values['ymsSpuList'], {emptyText: $t('key1001375')}) }}
                              </span>
                              <template #content>
                                <div>
                                  <Input
                                    v-model.trim="ruleItem.values['ymsSpuList']"
                                    type="textarea"
                                    :rows="4"
                                    style="width:400px"
                                    :placeholder="$t('key1001360')">
                                  </Input>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--商品的SKU为：指定SKU-->
                          <template v-if="['CORE-YPPCR-006','CORE-YPPMR-008', 'CORE-YPPSCR-006', 'CORE-YPPSMR-008'].includes(ruleItem.id)">
                            <Poptip transfer width="450" placement="bottom">
                               <span class="blueColor cursor">
                                {{ formatListValue(ruleItem.values['ymsSkuList'], {emptyText: $t('key1001369')}) }}
                              </span>
                              <template #content>
                                <div>
                                  <Input
                                    v-model.trim="ruleItem.values['ymsSkuList']"
                                    type="textarea"
                                    :rows="4"
                                    style="width:400px"
                                    :placeholder="$t('key1001356')">
                                  </Input>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--商品的供应商为：指定供应商-->
                          <template v-if="['CORE-YPPCR-005', 'CORE-YPPMR-005', 'CORE-YPPSCR-005', 'CORE-YPPSMR-005'].includes(ruleItem.id)">
                            <Poptip transfer width="450" placement="bottom">
                            <span class="blueColor cursor">
                              {{ formatListValue(ruleItem.values['supplierMerchantIds'], {emptyText: $t('key1001376')}) }}
                            </span>
                              <template #content>
                                <div>
                                  <Input
                                    v-model.trim="ruleItem.values['supplierMerchantIds']"
                                    type="textarea"
                                    :rows="4"
                                    style="width:400px"
                                    :placeholder="$t('key1001361')">
                                  </Input>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--购买商品的分销商为 ：指定分销商-->
                          <template v-if="['CORE-YPPMR-006', 'CORE-YPPSMR-006'].includes(ruleItem.id)">
                            <Poptip transfer width="450" placement="bottom">
                            <span class="blueColor cursor">
                              {{ formatListValue(ruleItem.values['distributorMerchantIdList'], {emptyText: $t('key1001377')}) }}
                            </span>
                              <template #content>
                                <div>
                                  <Input
                                    v-model.trim="ruleItem.values['distributorMerchantIdList']"
                                    type="textarea"
                                    :rows="4"
                                    style="width:400px"
                                    :placeholder="$t('key1001362')">
                                  </Input>
                                </div>
                              </template>
                            </Poptip>
                          </template>
                          <!--购买商品的分销商等级为 ：指定分销商等级-->
                          <template v-if="['CORE-YPPMR-007', 'CORE-YPPSMR-007'].includes(ruleItem.id)">
                            <span
                              v-if="!ruleItem.items[0]._isOperation"
                              class="blueColor itemPaddingRight cursor"
                              @click="editOperation(index,0)">
                              {{
                                !(ruleItem.values['distributorMerchantGradeList'] && ruleItem.values['distributorMerchantGradeList'].length) ? $t('key1001378') :
                                  customerGradeList.filter(j => ruleItem.values['distributorMerchantGradeList'].includes(j.ymsDistributorMerchantGradeId)).map(i => i.name).join(' ')
                              }}
                            </span>
                            <Select v-else v-model="ruleItem.values['distributorMerchantGradeList']" multiple style="width: 200px" filterable>
                              <Option v-for="item in customerGradeList" :key="item.ymsDistributorMerchantGradeId" :value="item.ymsDistributorMerchantGradeId">
                                {{ item.name }}
                              </Option>
                            </Select>
                          </template>
                        </template>
                      </div>
                    </div>
                  </template>
                  <p v-if="showTalg">
                    {{ $t('key1001436') }}
                  </p>
                </template>
              </div>
            </div>
          </div>
          <!--设定动作-->
          <div v-if="ruleType === 'declaration'">
            <!--申报规则-->
            <delarationDetail ref="declarationDetail" :hideSave="true" :isDisabled="isDisabled" class="rule-declaration"></delarationDetail>
            <div class="mt10">
              <span>{{ $t('key1001437') }}</span>
              <Input v-model.trim="ruleName" clearable class="w450"/>
            </div>
          </div>
          <!--智能物流规则-->
          <div v-else-if="['smartLogistics','distributorSmart'].includes(ruleType)">
            <smart-action ref="smartAction" :ruleType="ruleType" :isDisabled="isDisabled" :selectWareID="selectWareID"></smart-action>
          </div>
          <!--智能仓库规则-->
          <template v-else-if="ruleType === 'intelligentWarehouseRules'">
            <warehouseRuleModule ref="warehouseRules" @updateWarehouseRule="updateRuleFun"></warehouseRuleModule>
          </template>
          <!--商品销售价配置规则-->
          <template v-else-if="ruleType === 'productSalesPriceConfigRules'">
            <productSalesPriceConfigRulesModal
              ref="productSalesPriceConfigRules"
              :showProductWholesaleModel="showProductWholesaleModel"
              @updateProductSalesPriceConfigRule="updateRuleFun">
            </productSalesPriceConfigRulesModal>
          </template>
        </Col>
        <Col :span="9">
          <!--所有规则-->
          <div class="normalTop">
            <div class="modalItem rulesRightHeight">
              <div class="modalItemHeader">
                <h6>{{ $t('key1001438') }}</h6>
              </div>
              <div class="modalItemContent" style="max-height: 610px;overflow: auto">
                <template v-if="rules !== null && rules.length > 0">
                  <div v-for="(item, index) in rules" :key="index">
                    <div
                      v-if="((index >  0 && item.group !== rules[index - 1].group ) || index === 0) && item.group !== null"
                      class="groupTitle">
                      {{ item.groupDescription }}
                      <span style="position: relative; top: 1px; cursor: pointer;" v-if="item.groupDescription === 'Aliexpress'">
                          <Tooltip transfer :content="$t('key1001363')">
                          <Icon size="18" type="md-help-circle"/>
                        </Tooltip>
                        </span>
                    </div>
                    <Checkbox v-model="item._check" :disabled="isDisabled" @on-change="checkedHandel(item)">
                      <span v-html="item.display"></span>
                    </Checkbox>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <template #footer>
        <Button v-if="!isDisabled" type="primary" @click="save">{{ $t('key1000555') }}</Button>
        <Button @click="modal1=false">{{ $t('key1000112') }}</Button>
      </template>
    </Modal>
    <ruleTempAbnormal ref="ruleTempAbnormal"
      @confirm="OnRuleTempAbnormalConfirm"
    ></ruleTempAbnormal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import ruleMixin from '@/components/mixin/rule_mixin';
import ruleTempAbnormal from './ruleTempAbnormal';
import vueTreeSelect from '@riophae/vue-treeselect';
import {
  RULE_TYPE_IS,
  RULE_TYPE_INPUT,
  RULE_TYPE_TCI
} from '@/utils/enum';
import api from '@/api/';
import delarationDetail from '@/views/yms/components/basicSettings/delarationDetail';
import SmartAction from "@/views/yms/components/logisticsManage/smartAction";
import warehouseRuleModule from "@/views/distributor/components/warehouseManage/warehouseRuleModule.vue";
import productSalesPriceConfigRulesModal from "@/views/yms/components/commodityManage/productSalesPriceConfigRulesModal.vue";
import {
  getDeliveryAreasAllData, getCustomerLevelAll, getAllGoodsWarehouse, getCurrencyData,
  getAllYmsWarehouseData, getEnabledPlatforms, getYunLogisticsAll, getAllRuleItemEnumData, processingRuleItemData
} from "@/utils/common";

export default {
  name: 'newRule',
  mixins: [Mixin, ruleMixin],
  data() {
    return {
      modal1: false,
      spinShow: false,
      rules: null, // 所有规则
      ruleAction: null, // 规则动作
      ruleId: null, // 规则id
      isDisabled: false, // 规则id
      ruleName: '',
      basicPlatform: [],
      ruleTitle: '',
      ymsRuleType: '',
      yunShipList: [],
    };
  },
  computed: {
    showTalg() {
      return this.ruleType === 'productSalesPriceConfigRules' && this.rules.some((item) => item._check);
    }
  },
  created() {
  },
  props: {
    ruleType: {
      type: String,
      required: true
    },
    selectWareID: {
      type: String
    },
    // 是否开启批发模式
    showProductWholesaleModel: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  methods: {
    /**
     * 出参 入参需要处理
     * @date: 2021/10/21 14:24
     * @param type input output reset
     * @param ruleCode 规则id
     */
    ioHandle(ruleCode, type) {
      let v = this;
      if (['CORE-YCCR-002', 'CORE-YPDR-004', 'DISTRIBUTOR-DCCR-A003', 'DISTRIBUTOR-DWCR-A003'].includes(ruleCode)) {
        v.countryCodesAndPostCodeIO(type, ruleCode);
      } else if (['DISTRIBUTOR-DCCR-A002', 'DISTRIBUTOR-DWCR-A002'].includes(ruleCode)) {
        v.shipmentIO(type, ruleCode);
      } else if (['CORE-YCCR-005', 'DISTRIBUTOR-DWCR-A006', 'DISTRIBUTOR-DCCR-A006'].includes(ruleCode)) {
        /*金额订单总金额*/
        v.amountRangeIO(type, ruleCode);
      } else if (ruleCode === 'order-service-A034') {
        /*订单产品店铺SKU*/
        v.shopSkuModelIO(type, ruleCode);
      } else if (['CORE-YPDR-003'].includes(ruleCode)) {
        v.shippingIO(type, ruleCode);
      } else if (ruleCode === 'CORE-YPDR-007') {
        /*包裹货品*/
        v.productGoodsIO(type, ruleCode);
      } else if (['CORE-YPDR-005'].includes(ruleCode)) {
        v.totalPricesIO(type, ruleCode);
      } else if (['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(ruleCode)) {
        v.disOrderSourceIO(type, ruleCode);
      } else if (['CORE-YPDR-010', 'CORE-YCCR-006', 'DISTRIBUTOR-DCCR-A007', 'DISTRIBUTOR-DWCR-A007',
        'CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'].includes(ruleCode)) {
        let val = ['CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'].includes(ruleCode) ? 'original' : 'tile';
        v.productCategoryIO(type, ruleCode, val);
      } else if (['DISTRIBUTOR-DCCR-A009', 'DISTRIBUTOR-DWCR-A009', 'CORE-YCCR-007'].includes(ruleCode)) {
        v.streetsIO(type, ruleCode);
      } else if (['DISTRIBUTOR-DWCR-A029'].includes(ruleCode)) {
        v.warehouseNamesIO(type, ruleCode);
      }
    },
    fixParams() {
      let v = this;
      let params = [];
      if (v.rules) {
        v.rules.forEach(i => {
          if (i._check) {
            v.ioHandle(i.id, 'input');
            params.push({
              ruleCode: i.id,
              autoRuleParams: i.items.map(j => {
                let obj = {};
                obj.name = j.name;
                obj.type = j['valueType'] || 0;
                let valueKey = 'value';
                let val = i.values[j.name];
                if (obj.type === 1) {
                  valueKey = 'autoRuleParamValues';
                  if (v.typeOf(val) === 'string') {
                    let values = v.sepCommasFn(val);
                    val = values.map(i => {
                      return {
                        value: i
                      };
                    });
                    /*val = [{
                      value: val
                    }];*/
                  } else if (v.typeOf(val) === 'array') {
                    /*hack*/
                    if (val.length && val[0].hasOwnProperty('value')) {
                      // 处理之前已经处理的数据
                    } else {
                      val = val.map(i => {
                        return {
                          value: i
                        };
                      });
                    }

                  }
                }
                obj[valueKey] = j._disabled ? null : val;
                obj._typeName = valueKey;
                obj._disabledMapKey = [];
                if (j.name.includes('Checked') && obj[valueKey] !== true) {
                  obj._disabledMapKey = j.text.split(',');
                }
                return obj;
              })
            });
          }
        });
      }
      return params;
    },
    resetSpecialData() {
      const type = 'reset';
      this.countryCodesAndPostCodeIO(type);
      this.shipmentIO(type);
      this.shopSkuModelIO(type);
      this.shippingIO(type);
      this.disOrderSourceIO(type);
      this.productCategoryIO(type);
    },
    /**
     * 选择change事件
     * 处理特殊模板规则
     * @date: 2021/10/11 18:12
     */
    checkHandel(item, type) {
      let v = this;
      console.log('=====item.id=====', item.id)
      if (item.id === 'order-service-A001') {
        getEnabledPlatforms().then((data) => {
          v.shipmentPlatformList = data;
        });
      } else if (['CORE-YCCR-002', 'CORE-YPDR-004', 'DISTRIBUTOR-DCCR-A003', 'DISTRIBUTOR-DWCR-A003'].includes(item.id)) {
        v.getCommonCountry([]).then(data => {
          this.ruleCountryData = data;
        });
      } else if (['DISTRIBUTOR-DCCR-A002', 'DISTRIBUTOR-DWCR-A002'].includes(item.id)) {
        getEnabledPlatforms().then((data) => {
          v.shipmentPlatformList = data;
        });
      } else if (['DISTRIBUTOR-DCCR-A015', 'DISTRIBUTOR-DWCR-A015', 'CORE-YCCR-021'].includes(item.id)) {
        getCurrencyData();
      }
      // 获取所有仓库数据
      else if (['CORE-YCCR-023', 'CORE-YPDR-002'].includes(item.id)) {
        getAllYmsWarehouseData().then((data) => {
          v.warehouseList = data;
        });
      } else if (['CORE-YPDR-001', 'CORE-YCCR-001'].includes(item.id)) {
        getEnabledPlatforms().then((data) => {
          v.shipmentPlatformList = data;
        });
      } else if (['DISTRIBUTOR-DCCR-A001', 'DISTRIBUTOR-DWCR-A001'].includes(item.id)) {

      }
      // 获取所有分类数据
      else if (['CORE-YPDR-010', 'CORE-YCCR-006', 'DISTRIBUTOR-DCCR-A007',
        'DISTRIBUTOR-DWCR-A007', 'CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'].includes(item.id)) {
        let type = ['CORE-YPPCR-001', 'CORE-YPPMR-001', 'CORE-YPPSCR-001', 'CORE-YPPSMR-001'].includes(item.id) ? null : 'tile';
        v.getCloudSalesClassification(type);
      } else if (['CORE-YPDR-005'].includes(item.id)) {
        getCurrencyData()
      } else if (['CORE-YPDR-011'].includes(item.id)) {
        getYunLogisticsAll().then((data) => {
          v.yunShipList = data;
        });
      }
      // 获取所有发货地数据
      else if (['CORE-YPPCR-003', 'CORE-YPPMR-003', 'CORE-YPPSCR-003', 'CORE-YPPSMR-003'].includes(item.id)) {
        getDeliveryAreasAllData().then((data) => {
          v.placeOfShipmentList = data;
        });
        getAllGoodsWarehouse().then((data) => {
          v.shippingWarehouseList = data;
        });
      }
      // 获取客户等级所有数据
      else if (['CORE-YPPMR-007', 'CORE-YPPSMR-007'].includes(item.id)) {
        getCustomerLevelAll().then((data) => {
          v.customerGradeList = v.handleMultilinguaTableFields(data, ['name']);
        });
      }
    },
    /**
     * checkbox处理
     * @param value 当前值
     * @param index rule Index
     * @param rulesIndex 规则项name Index
     * */
    changeCheckbox(value, index, rulesIndex) {
      this.rules.forEach((i, ind) => {
        if (index === ind) {
          rulesIndex.forEach(j => {
            i.items[j]._disabled = !value;
          });
        }
      });
    },
    /**
     * 验证规则
     * @date: 2021/10/11 9:18
     * @param ruleCode 验证单条规则
     */
    validRule(ruleCode) {
      let v = this;
      let valid = true;
      // 不需要配置的规则项
      let ruleItemsList = ['CORE-YPPCR-002', 'CORE-YPPMR-002', 'CORE-YPPSCR-002', 'CORE-YPPSMR-002'];

      function mt(i, bo) {
        let hasValue = i.items.some(j => {
          let value = i.values[j.name];
          if (v.typeOf(value) === 'array') {
            if (value.length === 0) {
              value = null;
            }
          }
          if (j.name.includes('Checked') || j._disabled) {
            return false;
          } else if (j.name === 'allProduct') {
            return true;
          } else {
            return !!value;
          }
        });
        if (ruleItemsList.includes(i.id)) {
          hasValue = true;
        }

        if (!hasValue) {
          valid = false;
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001332') + i._prefixText);
        }
        if (bo && !valid) return;
        v.$set(i, '_checkStatus', valid); // define true
      }

      v.rules.forEach(i => {
        if (ruleCode) {
          if (i.id === ruleCode) mt(i, true);
        } else {
          if (i._check) mt(i);
        }
      });
      return valid;
    },
    /**
     * 保存
     * */
    save() {
      let v = this;
      let params = v.fixParams();
      params = v.checkedHandle(params); // checked处理;
      params = v.deleteNullValues(params);
      if (!v.validRule()) {
        return;
      }
      if (params.length === 0) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001333'));
        return;
      }
      // 申报规则
      if (v.ruleType === 'declaration') {
        if (!v.ruleName) {
          v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001334'));
          return;
        }
        v.declarationRuleSave(params);
      }
      // 智能物流规则
      else if (['smartLogistics', 'distributorSmart'].includes(v.ruleType)) {
        v.smartSave(params);
      }
      // 智能仓库规则
      else if (v.ruleType === 'intelligentWarehouseRules') {
        v.$refs['warehouseRules'].warehouseRuleModuleBtn(params);
      }
      // 商品销售价配置规则
      else if (v.ruleType === 'productSalesPriceConfigRules') {
        v.$refs['productSalesPriceConfigRules'].productSalesPriceConfigBtn(params);
      }
    },
    deleteNullValues(params) {
      params.forEach(r => {
        let rule = r.autoRuleParams;
        for (let i = rule.length; i--; i <= 0) {
          if ((rule[i].type === 0 && (rule[i].value === null || rule[i].value === ''))
            || (rule[i].type === 1 && (rule[i].autoRuleParamValues === null || rule[i].autoRuleParamValues.length === 0))) {
            if (rule[i].name !== 'allProduct') {
              rule.splice(i, 1);
            } else {
              rule[i].value = 'true';
            }
          }
        }
      });
      return params;
    },
    /**
     * checked 处理
     * @date: 2021/10/27 19:54
     * @param params 规则
     */
    checkedHandle(params) {
      params.forEach(i => {
        i.autoRuleParams.forEach(j => {
          j._disabledMapKey.forEach(name => {
            if (j.name === name) {
              j[j._typeName] = null;
            }
          });
        });
      });
      params.forEach(i => {
        i.autoRuleParams.forEach(j => {
          delete j._disabledMapKey;
          delete j._typeName;
        });
      });
      return params;
    },
    // 智能物流规则确定按钮
    smartSave(result) {
      let v = this;
      let obj = {
        autoRuleId: v.ruleAction.autoRuleId,
        name: v.ruleName,
        autoRuleItems: result,
        status: v.ruleAction.status,
        businessId: v.ruleAction.businessId
      };
      let valid = v.$refs.smartAction.validMt();
      if (!valid) {
        return;
      }
      let actionParmas = v.$refs.smartAction.setParams();
      obj.autoRuleActions = actionParmas.value;
      obj.name = actionParmas.ruleName;
      obj.status = actionParmas.status;
      if (!obj.name) {
        v.$Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001334'));
        return;
      }
      let postType = 'put';
      if (v.ruleAction.editType === 'add') {
        postType = 'post';
      }
      let apiUrl = v.ruleType === 'distributorSmart' ? api.post_ymsLogisServiceAutoRule : api.post_ymsCarrierAutoRule;
      v.spinShow = true;
      v.axios[postType](apiUrl, JSON.stringify(obj)).then(response => {
        v.loading = false;
        v.spinShow = false;
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
          v.modal1 = false;
          v.$emit('saveCallback', true);
        }
      }).catch(() => {
        v.spinShow = false;
      });
    },
    updateRuleFun() {
      this.modal1 = false;
      this.$emit('updateData', true);
    },
    // 申报规则确定按钮
    declarationRuleSave(result) {
      let v = this;
      let url = api.post_ymsPackageDeclareAutoRule;
      let postType = 'put';
      let obj;
      let valid = v.$refs.declarationDetail.validMt();
      if (!valid) {
        return;
      }
      let ruleDetail = v.$refs.declarationDetail.setParams();
      ruleDetail.ruleSetMatchId = v.autoRuleId;
      obj = {
        businessId: v.ruleAction.businessId,
        autoRuleId: v.ruleAction.autoRuleId,
        autoRuleActions: [
          {
            'type': 'ymsPackageDeclareRule',
            'value': null
          }
        ],
        name: v.ruleName,
        autoRuleItems: result,
        status: v.ruleAction.status,
        ymsPackageRuleDetail: ruleDetail
      };
      if (v.ruleAction.editType === 'add') {
        postType = 'post';
      }
      // v.loading = true;
      v.spinShow = true;
      v.axios[postType](url, JSON.stringify(obj)).then(response => {
        v.spinShow = false;
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113'));
          v.loading = false;
          v.modal1 = false;
          v.$emit('saveCallback', true);
        }
      }).catch(() => {
        v.spinShow = false;
        v.loading = false;
      });
    },
    dataToView(detail, rs) {
      this.ruleName = detail.selectedRule ? detail.selectedRule.name : '';
      this.ruleToView(detail.ruleItems, rs);
    },
    /**
     * 特殊参数处理 回调
     * 例如  后端认为是多个，前端是用的字符串
     * @date: 2021/10/28 17:00
     */
    specialParamsHandel(id, k, value) {
      // 纯字符串
      const te = [
        'DISTRIBUTOR-DCCR-A011', 'DISTRIBUTOR-DWCR-A011', 'CORE-YCCR-009', 'CORE-YPDR-009',
        'CORE-YPPCR-004', 'CORE-YPPMR-004', 'CORE-YPPSCR-004', 'CORE-YPPSMR-004',
        'CORE-YPPCR-006', 'CORE-YPPMR-008', 'CORE-YPPSCR-006', 'CORE-YPPSMR-008',
        'CORE-YPPCR-005', 'CORE-YPPMR-005', 'CORE-YPPSCR-005', 'CORE-YPPSMR-005',
        'CORE-YPPMR-006', 'CORE-YPPSMR-006'
      ];
      // 包含有字符串、数组，只对指定的字符串做处理
      const te1 = [
        'CORE-YPDR-010', 'CORE-YCCR-006', 'DISTRIBUTOR-DCCR-A007', 'DISTRIBUTOR-DWCR-A007',
        'CORE-YPPMR-006', 'CORE-YPPSMR-006', 'DISTRIBUTOR-DCCR-A027', 'DISTRIBUTOR-DWCR-A027', 'CORE-YCCR-022',
      ];
      // 需要处理的字符串key
      let keyList = ['skus'];
      if (te.includes(id)) {
        return value.join(',');
      } else if (te1.includes(id)) {
        if (keyList.includes(k.name)) {
          return value.join(',');
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    ruleToView(detail, rs) {
      let v = this;
      if (detail && detail.length) {
        detail.forEach(i => {
          rs.forEach(j => {
            if (i.ruleCode === j.id) {
              j._check = true;
              j.items.forEach(k => {
                if (i.ruleItemParams) {
                  i.ruleItemParams.forEach(p => {
                    let value;
                    if (k['valueType'] === 0) {
                      value = p.value;
                    } else {
                      if (p.ruleItemParamValues && p.ruleItemParamValues.length) {
                        value = p.ruleItemParamValues.map(i => i.value);
                        value = v.specialParamsHandel(i.ruleCode, k, value);
                      }
                    }
                    if (k.name === p.name) {
                      if (k.name.includes('Checked')) {
                        value = p.value === 'true';
                      }
                      k.value = p.value;
                      j.values[k.name] = value;
                    }
                  });
                }
              });
              i.id = i.ruleCode;
              v.checkHandel(i, 'toView');
            }
          });
        });
      }
      this.rules = rs;
      this.rules.forEach(i => {
        if (i._check) {
          v.ioHandle(i.id, 'output');
        }
      });
    },
    /**
     * 获取规则
     * @date: 2021/10/9 11:47
     */
    getRuleDetails(ruleItemEnumData) {
      let v = this;
      return new Promise((resolve) => {
        let apiUrl = null;
        switch (v.ruleType) {
          case 'smartLogistics':
            apiUrl = api.get_ymsCarrierAutoRule + v.ruleId;
            break;
          case 'declaration':
            apiUrl = api.get_ymsPackageDeclareAutoRule + v.ruleId;
            break;
          case 'distributorSmart':
            apiUrl = api.get_ymsLogisServiceAutoRule + v.ruleId;
            break;
          case 'intelligentWarehouseRules':
            apiUrl = api.get_ymsDistributorWarehouseAutoRule + v.ruleId;
            break;
          case 'productSalesPriceConfigRules':
            let url = '';
            if (['ymsProductPriceCommonRule', 'ymsProductPriceMerchantRule'].includes(v.ymsRuleType)) {
              url = api.get_ymsProductPriceRule;
            } else {
              url = api.get_ymsProductPriceServiceRule;
            }
            apiUrl = url + `?autoRuleId=${v.ruleId}&ymsRuleType=${v.ymsRuleType}`;
            break;
        }
        if (!apiUrl) return;
        v.spinShow = true;
        v.axios.get(apiUrl).then(response => {
          v.spinShow = false;
          if (response.data.code === 0) {
            let newData = response.data.datas;
            processingRuleItemData(ruleItemEnumData, newData).then((data) => {
              if (['edit', 'look'].includes(v.ruleAction.editType)) {
                if (['distributorSmart', 'smartLogistics'].includes(v.ruleType)) {
                  v.$refs.smartAction.fixDataToView({
                    ruleName: data.selectedRule.name,
                    status: data.selectedRule.status,
                    ruleActions: data.ruleActions
                  });
                }
              }
              let rs = v.initRuleData(data);
              v.dataToView(data, rs);
              resolve(data);
            });
          }
        }).catch(() => {
          v.spinShow = false;
        });
      });
    },
    /**
     * 初始化规则数据
     * */
    initRuleData(data) {
      console.log('initRuleData rules:', JSON.stringify(data.rules.map(i => ({id: i.id, items: i.items}))));
      return data.rules.map(i => {
        const _prefixTextList = i.display.split(/<span.*?<\/span>/g).map(t => t.trim()).filter(Boolean);
        i._check = false; // 是否选中
        i._checkStatus = true;
        i._prefixText = i.display.replace(/<span.*<\/span>/g, '');
        i._prefixTextList = _prefixTextList;
        i.checkbox1 = false;
        i.checkbox2 = false;
        i.checkbox3 = false;
        i.checkbox4 = false;
        if (RULE_TYPE_IS.includes(i.id)) i._ruleType = 'IS';
        if (RULE_TYPE_INPUT.includes(i.id)) i._ruleType = 'INPUT';
        if (RULE_TYPE_TCI.includes(i.id)) i._ruleType = 'TCI';
        i._guidanceText = i.display.replace(/.*>(.*)<.*/g, '$1'); // 帮助文字;
        i.values = {};
        i._status = {};
        i.items = (i.items || []).map(j => {
          let value = null;
          if (j.name && j.name.includes('Checked')) {
            value = false;
          }
          if (j.default !== undefined) {
            value = j.default;
          }
          i.values[j.name] = value;
          i._status[j.name] = false;
          // 类型是IS（是/否） 的下拉框，默认值：是   1
          if (i._ruleType === 'IS') {
            j.value = '1';
            i.values[j.name] = '1';
          }
          j.value = null;
          j._disabled = false;
          j._isOperation = false; // 规则项操作状态
          return j;
        });
        return i;
      });
    },
    /**
     * 改变编辑状态
     * 一个条件有多个对象的时候建议使用name
     * @date: 2021/10/11 17:25
     */
    editOperation(index, ruleIndex, name) {
      if (this.isDisabled) return;
      if (name) {
        this.rules[index].items.forEach((i, rIndex) => {
          if (i.name === name) {
            this.$set(this.rules[index]._status, name, true);
          }
        });
      } else {
        this.$set(this.rules[index].items[ruleIndex], '_isOperation', true);
      }
    },
    /**
     * 数据清空
     * @date: 2021/10/9 11:56
     */
    resetRuleData() {
      return new Promise(resolve => {
        this.rules = null;
        this.ruleTitle = '';
        const refMap = {
          declaration: 'declarationDetail', // 申报规则
          smartLogistics: 'smartAction', // 运营--智能物流规则
          distributorSmart: 'smartAction', // 分销商--智能物流规则
          intelligentWarehouseRules: 'warehouseRules', // 智能仓库规则
          productSalesPriceConfigRules: 'productSalesPriceConfigRules' // 商品销售价配置规则
        };

        const refName = refMap[this.ruleType];
        this.$refs[refName]?.reset();
        resolve();
      });
    },
    checkedHandel(item) {
      if (item._check) this.checkHandel(item, 'change');
    },
    open(ruleAction) {
      let v = this;
      v.ruleAction = ruleAction || {};
      v.ruleId = v.ruleAction.autoRuleId || 'null';
      v.isDisabled = this.ruleAction.editType === 'look';

      async function openInit() {
        let ruleItemEnumData = await getAllRuleItemEnumData();
        await v.resetRuleData();
        let titleObj = {
          declaration: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001335'),
          distributorSmart: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001336'),
          smartLogistics: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001336'),
          intelligentWarehouseRules: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001337'),
          productSalesPriceConfigRules: ruleAction.configValue === 'commonConfig' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001338') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001339'),
        }
        if (v.ruleType === 'productSalesPriceConfigRules') {
          const prefix = ruleAction.configStatus === '1' ? 'ymsProductPrice' : 'ymsProductPriceService';
          const suffix = ruleAction.configValue === 'commonConfig' ? 'CommonRule' : 'MerchantRule';
          v.ymsRuleType = `${prefix}${suffix}`;
        }
        let obj = {
          add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001340') + titleObj[v.ruleType],
          look: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401') + titleObj[v.ruleType],
          edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985') + titleObj[v.ruleType],
        }
        v.ruleTitle = obj[v.ruleAction.editType] || '';
        let detailsData = await v.getRuleDetails(ruleItemEnumData, v.ruleId);
        // 申报规则
        if (v.ruleType === 'declaration') {
          if (v.ruleAction.editType === 'edit') {
            v.$refs.declarationDetail.getRuleDetails(ruleItemEnumData, v.ruleAction.autoRuleId);
          }
        }
        // 智能物流规则
        else if (v.ruleType === 'distributorSmart') {
          v.$refs.smartAction.getYunShip();
        }
        // 智能仓库规则
        else if (v.ruleType === 'intelligentWarehouseRules') {
          v.$refs['warehouseRules'].initWarehouseRuleModuleData(detailsData, v.ruleAction.editType);
        }
        // 商品销售价配置规则
        else if (v.ruleType === 'productSalesPriceConfigRules') {
          v.$refs['productSalesPriceConfigRules'].initProductSalesPriceConfigRulesData(detailsData, v.ruleAction.editType, ruleAction);
        }
        // 分销商
        let pathname = window.location.pathname;
        if (pathname.includes('/distributor.html')) {
          getEnabledPlatforms().then((data) => {
            if (data && data.length > 0) {
              v.shipmentPlatformList = data;
              v.basicPlatform = data;
            }
          });
        } else {
          v.basicPlatform = [{
            platformId: 'ebay',
            name: 'Ebay'
          }];
        }
      }

      openInit();
      this.modal1 = true;
    },
    // 监听弹窗
    visibleChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.$refs.warehouseRules?.$refs?.warehouseRuleModuleForm?.resetFields();
          this.$refs.productSalesPriceConfigRules?.$refs?.productSalesPriceConfigForm?.resetFields();
          this.resetSpecialData();
        });
      }
    },
    // 选择发货地
    selectYmsDeliveryPlace(values, index) {
      let newYmsWarehouseIds = [];
      let ymsWarehouseIds = this.rules[index].values.ymsWarehouseIds || [];
      if (values && values.length > 0) {
        getAllGoodsWarehouse([], values).then((data) => {
          if (data && data.length > 0) {
            this.shippingWarehouseList = data;
            newYmsWarehouseIds = ymsWarehouseIds.filter(id => data.some(j => j.ymsWarehouseId === id));
            this.$set(this.rules[index].values, 'ymsWarehouseIds', newYmsWarehouseIds);
          } else {
            this.$set(this.rules[index].values, 'ymsWarehouseIds', []);
            this.shippingWarehouseList = [];
          }
        });
      } else {
        this.$set(this.rules[index].values, 'ymsWarehouseIds', []);
        this.shippingWarehouseList = [];
      }
    }
  },
  components: {
    SmartAction,
    ruleTempAbnormal,
    delarationDetail,
    vueTreeSelect,
    warehouseRuleModule,
    productSalesPriceConfigRulesModal
  }
};
</script>

<style>
.rule-declaration .ivu-form-item {
  margin-bottom: 10px;
}

.reset-form .ivu-form-item {
  margin-bottom: 16px;
}

.normalTop .ivu-checkbox-wrapper {
  display: inline !important;
}
</style>
<style lang="less" scoped>
.blueColor {
  margin-left: 5px;
  cursor: pointer;
  color: #0054a6;
}

.normalTop {
  margin-top: 10px;
}

.wid-70 {
  width: 70px;
}

.wid-150 {
  width: 150px;
}

.groupTitle {
  font-size: 14px;
  font-weight: bold;
}

.modalItemContent {
  padding: 10px;
}

.edit-style {
  margin-left: 5px;
  cursor: pointer;
  color: #0054a6;
}

.modalItemContent .error {
  color: #ff0000;
}

.checkboxContainer {
  min-height: 30px;
  padding: 10px;
  max-height: 300px;
  overflow: auto;
}

.group-description {
  margin-right: 5px;
  font-weight: 600;
}

.mr5 {
  margin-right: 5px;
}

.reset_vueTreeselect_style {
  vertical-align: middle;
  display: inline-block;

  /deep/ .vue-treeselect__control {
    line-height: initial !important;
    width: 250px;
    margin: 0 15px 0 5px;

    .vue-treeselect__multi-value {
      margin-bottom: 0;
    }

    .vue-treeselect__label {
      font-size: 13px;
    }
  }
}

</style>
